import { IHomeUnreadMessage, UNREAD_INFO, UNREAD_TYPE } from '@/schemas/common';
import { IJoinChatResponse } from '@/schemas/main-message';
import { IUnreadMsg, IMapUnread } from '@/schemas/order';
import { ApiConfigs, Response } from '@/schemas/service';
import { checkResponse } from '@/utils/helpers';
import { request } from './request';

const api: ApiConfigs = {
  // 批量查询客服消息
  queryCustomerServiceMessage: {
    url: '/health/api/v1/im/queryCustomerServiceMessage',
    method: 'GET'
  },
  // 批量查询医生未读咨询消息
  queryDoctorUnreadMessage: {
    url: '/health/api/v1/im/queryDoctorUnreadMessage',
    method: 'GET'
  },
  // 批量查询用户未读咨询消息
  queryUserUnreadMessage: {
    url: '/health/api/v1/im/queryUserUnreadMessage',
    method: 'GET'
  },
  // 批量查询开方医师未读咨询消息
  queryAssistantUnreadMessage: {
    url: '/health/api/v1/im/queryAssistantUnreadMessage',
    method: 'GET'
  },
  // 获取当前用户所有未读消息数,当前角色是医生时会获取所有解答未读和提问未读
  queryUnreadRemind: {
    url: '/health/api/v1/im/queryUnreadRemind',
    method: 'GET'
  },
  // 查询医生会话列表
  queryDoctorChatSessions: {
    url: '/health/api/v1/im/queryDoctorChatSessions',
    method: 'GET'
  },
  queryHomeUnreadMessage: {
    url: '/health/api/v1/im/queryUserHomeMessage',
    method: 'GET'
  },
  queryIMSessionParams: {
    url: '/health/api/v1/im/queryIMSessionParams',
    method: 'GET'
  },
  queryUnreadMessage: {
    url: '/health/api/v1/im/queryUnreadMessage',
    method: 'GET'
  },
  joinMainMessageChat: {
    url: '/health/api/v2/im/join-chat',
    method: 'GET'
  }
};

export interface IJoinChatParams {
  userId: string;
  doctorId: string;
  from: string;
  // 加null只是为了ts检查不报错
  role: number | null;
  scene: string;
  subBiz: string;
}

const im = {
  async queryCustomerServiceMessage() {
    try {
      const response: Response = await request(
        api.queryCustomerServiceMessage,
        undefined,
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getUserUnreadMsg(orderIds: string) {
    try {
      const response: Response = await request(
        api.queryUserUnreadMessage,
        {
          orderIds
        },
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      const target: {
        unreadList: IUnreadMsg[];
        unreadMap: IMapUnread;
        // totalUserUnread: number;
      } = {
        unreadList: [],
        unreadMap: {}
        // totalUserUnread: 0
      };
      target.unreadList = result;
      if (result.length) {
        result.forEach((item: IUnreadMsg) => {
          if (!target.unreadMap[item.orderId]) {
            target.unreadMap[item.orderId] = item.unreadCount;
          }
        });
        // target.totalUserUnread = result.reduce((acc, current: IUnreadMsg) => {
        //   return acc + current.unreadCount;
        // }, 0);
      }
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getDoctorUnreadMsg(orderIds: string) {
    try {
      const response: Response = await request(
        api.queryDoctorUnreadMessage,
        {
          orderIds
        },
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      const target: {
        unreadList: IUnreadMsg[];
        unreadMap: IMapUnread;
        // totalDoctorUnread: number;
      } = {
        unreadList: [],
        unreadMap: {}
        // totalDoctorUnread: 0
      };
      target.unreadList = result;
      if (result.length) {
        result.forEach((item: IUnreadMsg) => {
          if (!target.unreadMap[item.orderId]) {
            target.unreadMap[item.orderId] = item.unreadCount;
          }
        });
        // 计算总的未读数,在底部nav上显示用
        // target.totalDoctorUnread = result.reduce((acc, current: IUnreadMsg) => {
        //   return acc + current.unreadCount;
        // }, 0);
      }
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAssistantUnreadMsg(orderIds: string) {
    try {
      const response: Response = await request(
        api.queryAssistantUnreadMessage,
        {
          orderIds
        },
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      const target: {
        unreadList: IUnreadMsg[];
        unreadMap: IMapUnread;
        // totalDoctorUnread: number;
      } = {
        unreadList: [],
        unreadMap: {}
        // totalDoctorUnread: 0
      };
      target.unreadList = result;
      if (result.length) {
        result.forEach((item: IUnreadMsg) => {
          if (!target.unreadMap[item.orderId]) {
            target.unreadMap[item.orderId] = item.unreadCount;
          }
        });
        // 计算总的未读数,在底部nav上显示用
        // target.totalDoctorUnread = result.reduce((acc, current: IUnreadMsg) => {
        //   return acc + current.unreadCount;
        // }, 0);
      }
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAllUnread() {
    try {
      const response: any = await request(
        api.queryUnreadRemind,
        undefined,
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      const target: UNREAD_INFO = {
        unreadCount: result.unreadCount,
        pollingFrequency: +result.pollingFrequency
      };
      return target;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryDoctorChatSessions(payload) {
    try {
      const response = await request(api.queryDoctorChatSessions, payload);
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getHomeUnreadMessage() {
    try {
      const response: Response<IHomeUnreadMessage> = await request(
        api.queryHomeUnreadMessage
      );
      const { result, code } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return null;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async queryIMSessionParams(orderId: string) {
    try {
      const response: Response = await request(
        api.queryIMSessionParams,
        {
          orderId
        },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject(new Error('result is null'));
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // 改造群聊时新增api，如果是群聊的订单，需要从此api获取患者/医生未读消息数量
  async queryUnreadMessage(orderIds: number[]) {
    try {
      const response: Response<IUnreadMsg[]> = await request(
        api.queryUnreadMessage,
        {
          orderIds: orderIds?.join(',')
        },
        undefined,
        {
          hideToast: true
          // headers: {
          //   'Content-Type': 'application/json;charset=UTF-8'
          // }
        }
      );
      const { result } = response;
      if (result) {
        const target: {
          unreadList: IUnreadMsg[];
          unreadMap: IMapUnread;
        } = {
          unreadList: [],
          unreadMap: {}
        };
        target.unreadList = result;
        if (result.length) {
          result.forEach((item: IUnreadMsg) => {
            if (!target.unreadMap[item.orderId]) {
              target.unreadMap[item.orderId] = item.unreadCount;
            }
          });
        }
        return target;
      }
      return Promise.reject(new Error('result is null'));
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async joinMainMessageChat(params: IJoinChatParams) {
    try {
      const response: Response<IJoinChatResponse> = await request(
        api.joinMainMessageChat,
        { ...params },
        undefined,
        {
          hideToast: true
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default im;
